__turbopack_context__.v({
  "button": "askAiButton-module-scss-module__hzrL-W__button",
  "container": "askAiButton-module-scss-module__hzrL-W__container",
  "icon": "askAiButton-module-scss-module__hzrL-W__icon",
  "label": "askAiButton-module-scss-module__hzrL-W__label",
});
